<template>
    <div>
        <header-component></header-component>
        <div class="container">
            <div class="registration-success g-py-170">
                <div class="row">
                    <div class="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-12 offset-sm-0 col-xs-12 offset-sm-0">
                        <div class="success-div" v-if="!isLoading">
                            <p class="heading">{{messageHeader}}!</p>
                            <p class="success_msg" v-if="isSuccess">
                                You have successfully activated your account <br><router-link :to=" {name: 'Home'}">click here</router-link> to go to the log in page.
                            </p>
                            <p class="success_msg" v-else>
                                Invalid activation code. Please try again.
                            </p>
                        </div>
                        <div class="success-div" v-if="isLoading">
                            <img src="../../../static/img/loading.gif">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer-component></footer-component>
    </div>
</template>

<script>
    import HeaderComponent from "@/components/shared/HeaderComponent";
    import FooterComponent from "@/components/shared/FooterComponent";
    export default {
        components: {HeaderComponent, FooterComponent},
        data(){
            return{
                isLoading:true,
                messageHeader:'',
                isSuccess:false
            }
        },
        methods:{
            VerifyAccount(){
                var _this = this;
                axios.get('/Account/Verify/' + this.$route.params.code)
                .then(function (response) {
                    _this.isLoading = false;
                    _this.isSuccess = response.data.isSuccess;
                    if(response.data.isSuccess){
                        _this.messageHeader="Congratulations"
                    }else{
                        _this.messageHeader="Error"
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            }
        },
        created(){
            this.VerifyAccount();
        }
    }
</script>



// WEBPACK FOOTER //
// Activation.vue?48e5c0ea